import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { finalize } from 'rxjs/operators';
import { WorkflowAssistantSuggestionService } from './workflow-assistant-suggestion.service';
import { richTextRequired, WORKFLOW_ASSISTANT_QUILL_CONFIG, WORKFLOW_ASSISTANT_RICH_TEXT_MAX_LENGTH } from './workflow-assistant-quill';

export interface WorkflowAssistantFeedbackDialogData {
  question: string;
  assistantAnswer: string;
}

@Component({
  selector: 'app-workflow-assistant-feedback-dialog',
  templateUrl: './workflow-assistant-feedback-dialog.component.html',
  styleUrls: ['./workflow-assistant-feedback-dialog.component.scss'],
})
export class WorkflowAssistantFeedbackDialogComponent {
  readonly feedbackForm: FormGroup;
  readonly quillConfig = WORKFLOW_ASSISTANT_QUILL_CONFIG;
  submitting = false;
  error = '';

  constructor(
    formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: WorkflowAssistantFeedbackDialogData,
    private suggestionService: WorkflowAssistantSuggestionService,
    public dialogRef: MatDialogRef<WorkflowAssistantFeedbackDialogComponent>,
  ) {
    this.feedbackForm = formBuilder.group({
      expectedBehavior: ['', [richTextRequired(), Validators.maxLength(WORKFLOW_ASSISTANT_RICH_TEXT_MAX_LENGTH)]],
    });
  }

  /**
   * Validates and submits the visible question-answer exchange for SA review.
   */
  submit(): void {
    if (this.feedbackForm.invalid) {
      this.feedbackForm.markAllAsTouched();
      return;
    }

    this.submitting = true;
    this.error = '';
    this.suggestionService.reportIncorrectAnswer({
      question: this.data.question,
      assistantAnswer: this.data.assistantAnswer,
      expectedBehavior: this.feedbackForm.value.expectedBehavior.trim(),
    }).pipe(finalize(() => this.submitting = false)).subscribe({
      next: () => this.dialogRef.close(true),
      error: () => this.error = 'The report could not be submitted. Please try again.',
    });
  }
}
